export default [
    { index: 1, val: "AS", name: "Asistió", style: "light-success" },
    { index: 2, val: "NL", name: "No Laborable", style: "light-warning" },
    { index: 3, val: "TR", name: "Trabajo Remoto", style: "light-primary" },
    {
        index: 4,
        val: "SH",
        name: "Sin Horario",
        style: "light-warning",
    },
    { index: 5, val: "NM", name: "No Marcó", style: "light-danger" },
    { index: 6, val: "JS", name: "Justificado", style: "light-primary" },
    { index: 7, val: "RC", name: "Rechazado", style: "light-danger" },
    { index: 8, val: "PE", name: "Pendiente", style: "light-warning" },
    { index: 9, val: "FE", name: "Feriado", style: "light-info" },
    { index: 10, val: "TA", name: "Tardanza", style: "light-warning" },
    { index: 11, val: "VA", name: "Vacaciones", style: "light-primary" },
    { index: 12, val: "VC", name: "Vacaciones Compradas", style: "light-success" },
    { index: 13, val: "FA", name: "Falta", style: "light-danger" },
];